// ─────────────────────────────────────────────────────────────────────────────
// ImgFill, a tiny <img>-with-graceful-fallback overlay for art boxes across the
// roster surface (release covers, playlist/track thumbnails, campaign thumbs,
// rail avatars). It renders the existing gradient/letter placeholder as the BASE
// and overlays an absolutely-positioned <img> that fills the box (object-fit:
// cover, inherited border-radius). When the URL is null/empty OR the image fails
// to load (onError), the <img> is dropped and ONLY the placeholder shows, never
// a broken-image icon (honest fallback, Bible 06.4).
//
// Usage: place inside the existing placeholder element (which keeps its classes /
// styling). The placeholder must be position:relative-able; we wrap nothing and
// rely on absolute positioning over the parent, which the art boxes already size.
// ─────────────────────────────────────────────────────────────────────────────

import { useState } from 'react';
import type { JSX } from 'react';

export function ImgFill({
  src,
  alt = '',
}: {
  readonly src: string | null | undefined;
  readonly alt?: string;
}): JSX.Element | null {
  const [failed, setFailed] = useState(false);
  const url = typeof src === 'string' ? src.trim() : '';
  if (!url || failed) return null;
  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: 'inherit',
        display: 'block',
      }}
    />
  );
}
